import { useState } from 'react';
import { motion } from 'framer-motion';

export function SupportSection() {
  const [msg, setMsg] = useState('');
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (!msg.trim()) return;

    setSubmitted(true);
    setTimeout(() => {
      setMsg('');
      setSubmitted(false);
      alert('Feedback submitted successfully! Our support team will review it.');
    }, 1000);
  };

  return (
    <div className="space-y-4 text-left select-none">
      <h4 className="text-[10px] font-black uppercase tracking-wider text-amber-300 font-mono">
        Contact Support & Feedback
      </h4>

      <form onSubmit={handleSubmit} className="space-y-2">
        <textarea
          value={msg}
          onChange={(e) => setMsg(e.target.value)}
          placeholder="Describe your issue or provide feedback..."
          className="w-full h-20 px-3.5 py-2.5 text-xs rounded-xl bg-slate-950/40 border border-white/10 text-white placeholder-slate-600 focus:outline-none focus:border-purple-500/50 transition-colors shadow-inner resize-none"
        />
        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          disabled={!msg.trim() || submitted}
          className={`w-full py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest cursor-pointer transition-all ${
            msg.trim()
              ? 'bg-purple-600 border border-purple-500/20 text-white shadow-glow'
              : 'bg-slate-800 border border-white/5 text-surface-500 cursor-not-allowed'
          }`}
        >
          {submitted ? 'Submitting...' : 'Send Message'}
        </motion.button>
      </form>

      {/* Support Info lists */}
      <div className="pt-2 space-y-1.5 text-[9px] font-mono text-surface-500 leading-normal">
        <div>📧 support@tambolagame.com</div>
        <div>💬 Discord: discord.gg/tambola</div>
      </div>
    </div>
  );
}
export default SupportSection;
